document.addEventListener("DOMContentLoaded", function () {
  const sizeCheckboxes = document.querySelectorAll(".checkbox-button");
  const headboardCheckboxes = document.querySelectorAll(".checkbox-button-headboard-group");
  const bedbaseCheckboxes = document.querySelectorAll(".checkbox-button-bedbase-group");
  const mattressCheckboxes = document.querySelectorAll(".checkbox-button-mattress-group");
  const splitMattressCheckboxes = document.querySelectorAll(".checkbox-button-split-mattress-group");
  const splitMattressSection = document.getElementById('split-mattress-section');
  const mattressNoSelect = document.getElementById("mattress-no-select");

  // Preload all images
  const preloadImages = () => {
    const imageUrls = new Set();

    function collectImages(checkboxes) {
      checkboxes.forEach((checkbox) => {
        const imageUrl = checkbox.getAttribute("data-cbcimage");
        if (imageUrl) {
          imageUrls.add(imageUrl);
        }
      });
    }

    collectImages(headboardCheckboxes);
    collectImages(bedbaseCheckboxes);
    collectImages(mattressCheckboxes);
    collectImages(splitMattressCheckboxes);

    imageUrls.forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  };

  preloadImages();

  function updateTitleSpan(checkboxes, titleSpanId, linkId) {
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        const titleSpan = document.getElementById(titleSpanId);
        const link = linkId ? document.getElementById(linkId) : null;
        titleSpan.textContent = this.getAttribute("data-title") || this.nextElementSibling.textContent;

        if (link) {
          if (this.getAttribute("data-purl")) {
            link.href = this.getAttribute("data-purl");
            link.style.display = "inline";
          } else {
            link.href = "#";
            link.style.display = "none";
          }
        }

        if (this.checked) {
          checkboxes.forEach((cb) => cb !== this && (cb.checked = false));
          updatePriceSpans();
        }
      });

      if (checkbox.checked) {
        const titleSpan = document.getElementById(titleSpanId);
        const link = linkId ? document.getElementById(linkId) : null;
        titleSpan.textContent = checkbox.getAttribute("data-title") || checkbox.nextElementSibling.textContent;
        if (link) {
          if (checkbox.getAttribute("data-purl")) {
            link.href = checkbox.getAttribute("data-purl");
            link.style.display = "inline";
          } else {
            link.href = "#";
            link.style.display = "none";
          }
        }
      }
    });
  }

  function updateContainers() {
    const checkedSizeCheckbox = Array.from(sizeCheckboxes).find((checkbox) => checkbox.checked);
    const selectedSizeId = checkedSizeCheckbox ? checkedSizeCheckbox.id : "";

    const containers = document.querySelectorAll('[id^="group-"], [id^="group-mattress-"], [id^="group-split-mattress-"]');
    containers.forEach((container) => {
      if (
        container.id === "group-" + selectedSizeId ||
        container.id === "group-mattress-" + selectedSizeId ||
        container.id === "group-split-mattress-" + selectedSizeId
      ) {
        container.style.display = "flex";
      } else {
        container.style.display = "none";
      }
    });

    // Show or hide split mattress section based on "Split King" selection
    if (selectedSizeId === 'split-king') {
      if (splitMattressSection) {
        splitMattressSection.style.display = 'block';
      }
    } else {
      if (splitMattressSection) {
        splitMattressSection.style.display = 'none';
        resetSplitMattressSelection();
      }
    }

    resetGroupSelections();
    updateTitleSpans();
  }

  function resetGroupSelections() {
    const headboardNoSelect = document.getElementById("headboard-no-select");
    const bedbaseNoSelect = document.getElementById("bedbase-no-select");

    if (headboardNoSelect) headboardNoSelect.checked = true;
    if (bedbaseNoSelect) bedbaseNoSelect.checked = true;
    if (mattressNoSelect) mattressNoSelect.checked = true;

    document.querySelectorAll(".checkbox-button-headboard-group").forEach((cb) => {
      if (cb !== headboardNoSelect) cb.checked = false;
    });

    document.querySelectorAll(".checkbox-button-bedbase-group").forEach((cb) => {
      if (cb !== bedbaseNoSelect) cb.checked = false;
    });

    document.querySelectorAll(".checkbox-button-mattress-group").forEach((cb) => {
      if (cb !== mattressNoSelect) cb.checked = false;
    });

    updateImagesAfterDelay();
  }

  function resetSplitMattressSelection() {
    const splitMattressNoSelect = document.getElementById("split-mattress-no-select");
    if (splitMattressNoSelect) splitMattressNoSelect.checked = true;

    document.querySelectorAll(".checkbox-button-split-mattress-group").forEach((cb) => {
      if (cb !== splitMattressNoSelect) cb.checked = false;
    });

    const splitMattressTitle = document.getElementById("split-mattress-title");
    const splitMattressLink = document.getElementById("split-mattress-selected-link");
    if (splitMattressTitle) splitMattressTitle.textContent = "No Selection";
    if (splitMattressLink) splitMattressLink.style.display = "none";

    updateImagesAfterDelay();
  }

  function updateTitleSpans() {
    const headboardTitle = document.getElementById("headboard-title");
    const bedbaseTitle = document.getElementById("bedbase-title");
    const mattressTitle = document.getElementById("mattress-title");
    const splitMattressTitle = document.getElementById("split-mattress-title");

    const headboardLink = document.getElementById("headboard-selected-link");
    const bedbaseLink = document.getElementById("bedbase-selected-link");
    const mattressLink = document.getElementById("mattress-selected-link");
    const splitMattressLink = document.getElementById("split-mattress-selected-link");

    if (headboardTitle) headboardTitle.textContent = "No Selection";
    if (bedbaseTitle) bedbaseTitle.textContent = "No Selection";
    if (mattressTitle) mattressTitle.textContent = "No Selection";
    if (splitMattressTitle) splitMattressTitle.textContent = "No Selection";

    if (headboardLink) headboardLink.style.display = "none";
    if (bedbaseLink) bedbaseLink.style.display = "none";
    if (mattressLink) mattressLink.style.display = "none";
    if (splitMattressLink) splitMattressLink.style.display = "none";

    updateTitleSpan(sizeCheckboxes, "size-title");
    updateTitleSpan(headboardCheckboxes, "headboard-title", "headboard-selected-link");
    updateTitleSpan(bedbaseCheckboxes, "bedbase-title", "bedbase-selected-link");
    updateTitleSpan(mattressCheckboxes, "mattress-title", "mattress-selected-link");
    updateTitleSpan(splitMattressCheckboxes, "split-mattress-title", "split-mattress-selected-link");
  }

  function updateDivVisibility() {
    const selectedSize = Array.from(sizeCheckboxes).find((checkbox) => checkbox.checked)?.id || "";

    const productItems = document.querySelectorAll(".product-item-mattress, .product-item-split-mattress");

    productItems.forEach((item) => {
      const divSize = item.getAttribute("data-size");

      if (selectedSize === divSize) {
        item.style.display = "flex";
      } else {
        item.style.display = "none";
      }
    });
  }

  function ensureSingleSelection(checkboxes) {
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        if (this.checked) {
          checkboxes.forEach((cb) => cb !== this && (cb.checked = false));
        }
      });
    });
  }

  function updateImage(containerId, imageUrl, isSoldOut) {
    const container = document.getElementById(containerId);
    if (container) {
      container.classList.toggle("sold___out", isSoldOut);
      const imgElement = container.querySelector("img");

      if (imgElement) {
        imgElement.classList.remove("fade-rise-in");
        imgElement.classList.add("fade-drop-out");

        imgElement.addEventListener("transitionend", function () {
          imgElement.src = imageUrl;
          imgElement.classList.remove("fade-drop-out");
          imgElement.classList.add("fade-rise-in");
        }, { once: true });
      } else {
        container.innerHTML = imageUrl ? `<img src="${imageUrl}" alt="Selected Image" class="fade-rise fade-rise-in">` : "";
      }
    }
  }

  function handleSelection(checkboxes, containerId) {
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        const imageUrl = this.getAttribute("data-cbcimage") || "";
        const isSoldOut = this.getAttribute("data-soldout") === "yes";
        updateImage(containerId, imageUrl, isSoldOut);

        const titleSpan = document.getElementById(containerId.replace('-image-container', '') + '-title');
        titleSpan.textContent = this.getAttribute("data-title") || this.nextElementSibling.textContent;

        if (isSoldOut) {
          checkboxes.forEach((cb) => cb.checked = false);
        } else if (this.checked) {
          checkboxes.forEach((cb) => cb !== this && (cb.checked = false));
        }
        updatePriceSpans();
      });

      if (checkbox.checked) {
        const imageUrl = checkbox.getAttribute("data-cbcimage") || "";
        const isSoldOut = checkbox.getAttribute("data-soldout") === "yes";
        updateImage(containerId, imageUrl, isSoldOut);

        const titleSpan = document.getElementById(containerId.replace('-image-container', '') + '-title');
        titleSpan.textContent = checkbox.getAttribute("data-title") || checkbox.nextElementSibling.textContent;
      }
    });
  }

  function updateImagesAfterDelay() {
    setTimeout(() => {
      handleSelection(headboardCheckboxes, "headboard-image-container");
      handleSelection(bedbaseCheckboxes, "bedbase-image-container");
      handleSelection(mattressCheckboxes, "mattress-image-container");
      handleSelection(splitMattressCheckboxes, "split-mattress-image-container");
    }, 100);
  }

  sizeCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      if (this.checked) {
        sizeCheckboxes.forEach((cb) => cb !== this && (cb.checked = false));
        updateContainers();
        updateDivVisibility();
        resetGroupSelections();
      }
    });
  });

  function updatePriceSpans() {
    const selectedMattress = document.querySelector(".checkbox-button-mattress-group:checked");
    const selectedSplitMattress = document.querySelector(".checkbox-button-split-mattress-group:checked");
    const selectedBedbase = document.querySelector(".checkbox-button-bedbase-group:checked");
    const selectedHeadboard = document.querySelector(".checkbox-button-headboard-group:checked");

    const mattressPrice = selectedMattress && selectedMattress.getAttribute("data-soldout") !== "yes" ? parseFloat(selectedMattress.getAttribute("data-price")) || 0 : 0;
    const splitMattressPrice = selectedSplitMattress && selectedSplitMattress.getAttribute("data-soldout") !== "yes" ? parseFloat(selectedSplitMattress.getAttribute("data-price")) || 0 : 0;
    const bedbasePrice = selectedBedbase && selectedBedbase.getAttribute("data-soldout") !== "yes" ? parseFloat(selectedBedbase.getAttribute("data-price")) || 0 : 0;
    const headboardPrice = selectedHeadboard && selectedHeadboard.getAttribute("data-soldout") !== "yes" ? parseFloat(selectedHeadboard.getAttribute("data-price")) || 0 : 0;

    const totalPrice = mattressPrice + splitMattressPrice + bedbasePrice + headboardPrice;

    document.getElementById("selected-mattress-price").textContent = `$${mattressPrice.toFixed(2)}`;
    document.getElementById("split-selected-mattress-price").textContent = `$${splitMattressPrice.toFixed(2)}`;
    document.getElementById("selected-bedbase-price").textContent = `$${bedbasePrice.toFixed(2)}`;
    document.getElementById("selected-headboard-price").textContent = `$${headboardPrice.toFixed(2)}`;
    document.getElementById("grand-total").textContent = `$${totalPrice.toFixed(2)}`;
  }

  // Call updatePriceSpans initially to set the initial total price
  updatePriceSpans();

  handleSelection(headboardCheckboxes, "headboard-image-container");
  handleSelection(bedbaseCheckboxes, "bedbase-image-container");
  handleSelection(mattressCheckboxes, "mattress-image-container");
  handleSelection(splitMattressCheckboxes, "split-mattress-image-container");

  ensureSingleSelection(headboardCheckboxes);
  ensureSingleSelection(bedbaseCheckboxes);
  ensureSingleSelection(mattressCheckboxes);
  ensureSingleSelection(splitMattressCheckboxes);

  updateContainers();
  updateTitleSpans();
  updateDivVisibility();
});

// Add To Cart Method
document.addEventListener("DOMContentLoaded", function () {
  const bundleForm = document.getElementById("bundle-form");

  if (bundleForm) {
    bundleForm.addEventListener("submit", async function (e) {
      e.preventDefault(); // Prevents the form from submitting normally

      async function addProductById(variantId, quantity = 1) {
        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ id: variantId, quantity: quantity }),
          });
          const data = await response.json();
          console.log("Product added:", data);
          return data;
        } catch (error) {
          console.error("Error adding product:", error);
          throw error; // Rethrow to handle higher up
        }
      }

      async function addBundleProducts(bundleProducts) {
        try {
          const products = bundleProducts.split(',');

          for (const product of products) {
            const variantId = product.trim();
            console.log("Adding product:", variantId, "Quantity:", 1);

            await addProductById(variantId, 1);
          }
        } catch (error) {
          console.error("Error adding bundle products:", error);
          throw error; // Rethrow to handle higher up
        }
      }

      const tryToAddMainProduct = async (variantId, attempts = 0) => {
        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
          const data = await response.json();
          if (data.status === "error" && attempts < 10) {
            // Checking status and limiting retries
            console.log("Retrying to add main product, attempt:", attempts + 1);
            await new Promise((resolve) => setTimeout(resolve, 1000)); // Wait 1 second before retrying
            return tryToAddMainProduct(variantId, attempts + 1);
          } else if (data.status === "error") {
            throw new Error(
              "Failed to add main product after multiple attempts."
            );
          }
          console.log("Main product added:", data);
          return data;
        } catch (error) {
          throw error;
        }
      };

      try {
        const headboardVariant = document.querySelector(
          ".checkbox-button-headboard-group:checked"
        );
        const bedbaseVariant = document.querySelector(
          ".checkbox-button-bedbase-group:checked"
        );
        const mattressVariant = document.querySelector(
          ".checkbox-button-mattress-group:checked"
        );
        const splitMattressVariant = document.querySelector(
          ".checkbox-button-split-mattress-group:checked"
        );

        // Add headboard if selected
        if (headboardVariant) {
          const headboardVariantId = headboardVariant.getAttribute("data-varheadboard");
          const bundleProducts = headboardVariant.getAttribute("data-bundle-products");

          if (bundleProducts) {
            await addBundleProducts(bundleProducts);
          } else {
            await tryToAddMainProduct(headboardVariantId); // Try to add the headboard product with retries
          }
        }

        // Add bedbase if selected
        if (bedbaseVariant) {
          const bedbaseVariantId = bedbaseVariant.getAttribute("data-varbedbase");
          const bundleProducts = bedbaseVariant.getAttribute("data-bundle-products");

          if (bundleProducts) {
            await addBundleProducts(bundleProducts);
          } else {
            await addProductById(bedbaseVariantId); // Add the bedbase product
          }
        }

        // Add first mattress if selected
        if (mattressVariant) {
          const mattressVariantId = mattressVariant.getAttribute("data-varmattress");
          const bundleProducts = mattressVariant.getAttribute("data-bundle-products");

          if (bundleProducts) {
            await addBundleProducts(bundleProducts);
          } else {
            await addProductById(mattressVariantId); // Add the mattress product
          }
        }

        // Add second (split) mattress if selected
        if (splitMattressVariant) {
          const splitMattressVariantId = splitMattressVariant.getAttribute("data-varmattress");
          console.log("Split Mattress Variant ID:", splitMattressVariantId);
          if (splitMattressVariantId) {
            await addProductById(splitMattressVariantId); // Add the split mattress product
          } else {
            console.error("No Split Mattress Variant ID found.");
          }
        }

        // Navigate to the cart page after all products are added
        window.location.href = "/cart";
      } catch (error) {
        console.error("Failed to add products:", error);
        alert("Failed to add products. Please try again later.");
      }
    });
  } else {
    console.error("Bundle form not found");
  }
});

